import throttle from 'lodash.throttle';
import {
  FormEvent,
  KeyboardEventHandler,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Field, FieldWrapper, Label, TextAreaWrapper } from './styles';

export type TextareaInputEventType = FormEvent<HTMLTextAreaElement> & {
  target: HTMLTextAreaElement;
};
type TextAreaProps = {
  onChange?: (event: TextareaInputEventType) => void;
  onKeyDown?: KeyboardEventHandler;
  initialHeight?: string;
  paddingY?: string;
  label?: string;
  id: string;
  name: string;
  value?: string;
  className?: string;
  fontSize?: string;
  placeholder?: string;
  borderRadius?: string;
  grayInput?: boolean;
};

export function TextArea({
  onChange,
  initialHeight,
  paddingY,
  label,
  id,
  name,
  value,
  onKeyDown,
  className,
  fontSize,
  placeholder,
  borderRadius,
  grayInput = false,
}: TextAreaProps): JSX.Element {
  const [content, setContent] = useState(value);

  useEffect(() => {
    setContent(value);
  }, [value]);

  const handleChange = useMemo(
    () =>
      throttle((event: TextareaInputEventType) => {
        setContent(String(event.target.value));
        onChange(event);
      }, 16),
    [onChange],
  );
  return (
    <FieldWrapper className={className}>
      <TextAreaWrapper
        data-content={content}
        $initialHeight={initialHeight}
        $paddingY={paddingY}
        $borderRadius={borderRadius}
        $grayInput={grayInput}
      >
        <Field
          name={name}
          id={id}
          onInput={handleChange}
          value={content}
          rows={1}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          $fontSize={fontSize}
        />
        {label && !content && (
          <Label htmlFor={id} $content={content} $insetY={paddingY}>
            {label}
          </Label>
        )}
      </TextAreaWrapper>
    </FieldWrapper>
  );
}

TextArea.defaultProps = {
  initialHeight: '75px',
  value: '',
  onKeyDown: null,
  onChange: null,
};
